import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container, Paper, Typography, Box } from '@mui/material';
import { AppStoreLinks } from '../../shared/components/AppStoreLinks';
import { ProductList } from '../components/ProductList';
export const PurchasePage = () => {
    // Helper function to detect if the user is on a mobile device
    const isMobile = () => /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    return (_jsxs(Container, Object.assign({ sx: {
            width: '100%',
            minHeight: 'calc(100vh - 64px)',
            paddingTop: {
                xs: 'calc(32px + 56px)',
                md: 'calc(32px + 64px)',
            },
            paddingBottom: '32px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start',
        } }, { children: [!isMobile() && (_jsx(Paper, Object.assign({ elevation: 3, sx: {
                    width: '540px',
                    maxWidth: '100%',
                    padding: 4,
                    margin: 'auto',
                } }, { children: _jsxs(Box, Object.assign({ sx: { marginBottom: 4 } }, { children: [_jsx(Typography, Object.assign({ variant: "h5", align: "center", gutterBottom: true }, { children: "Get the App" })), _jsx(Typography, Object.assign({ variant: "body1", align: "center", gutterBottom: true }, { children: "Purchases can only be made on a mobile device using the app." })), _jsx(Typography, Object.assign({ variant: "body1", align: "center", sx: { mb: 4 }, gutterBottom: true }, { children: "Download using one of the links below:" })), _jsx(AppStoreLinks, { packageName: "works.gago.tasks", appStoreId: "undefined", iosStatus: "comingSoon", androidStatus: "active" })] })) }))), isMobile() ? _jsx(ProductList, {}) : null] })));
};
